<template>
    <div class="polymerisation">
        <img
            src="@/assets/img/reaktionen/polymerisation-1.png"
            alt="Polymerisation"
            title="Polymerisation"
        />
        <img
            src="@/assets/img/reaktionen/polymerisation-2.png"
            alt="Polymerisation"
            title="Polymerisation"
        />
        <small><a href="Polymerisation" target="_blank">Quelle</a></small>
    </div>
</template>

<script>
export default {
    name: 'polymerisation',
};
</script>
